import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v32.12.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "@arcgis/core/widgets/Search";
import t from "@arcgis/core/geometry/Point";
import s from "@arcgis/core/Graphic";
import i from "@arcgis/core/geometry/SpatialReference";
import a from "@arcgis/core/widgets/Search/LocatorSearchSource";
import { R as r, a7 as o, b as n, Q as h, aB as l, aC as c } from "../api/rec.js";
import { f as p } from "../non-field-feature.js";
import "uuid";
import "@arcgis/core/geometry/Polygon";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import { T as d } from "../index.js";
import "lodash";
import { S as m } from "../symbols.js";

var g = n("reference", "v1.0"),
    fetchSpatial = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
    var s, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            s = new h();
            s.append("spatialReference", "wgs84"), t && s.append("extent", t.spatialReference.isWebMercator ? o.extentToQueryParameter(o.webMercatorToGeographic(t)) : o.extentToQueryParameter(t));
            i = g("plss/spatial/".concat(e, "?").concat(s.toString()));
            return _context.abrupt("return", r.get(i).then(function (e) {
              var t = e.results;
              return t.map(transformShape);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSpatial(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(),
    transformShape = function transformShape(e) {
  return o.geometryFromApiInplace(e, "shape", o.getSpatialReference(102100));
},
    fetchStates = function fetchStates() {
  var e = g("plss/state");
  return r.get(e).then(function (e) {
    var t = e.results;
    return t.map(function (e) {
      return {
        name: e
      };
    });
  });
},
    fetchTownships = function fetchTownships(e) {
  var t = new h();
  t.append("spatialReference", "wgs84"), e && t.append("state", e);
  var s = g("plss/township?".concat(t.toString()));
  return r.get(s).then(function (e) {
    var t = e.results;
    return t.map(function (e) {
      return {
        name: e
      };
    });
  });
},
    fetchRanges = function fetchRanges(e, t) {
  var s = new h();
  e && s.append("state", e), t && s.append("township", t);
  var i = g("plss/range?".concat(s.toString()));
  return r.get(i).then(function (e) {
    var t = e.results;
    return t.map(function (e) {
      return {
        name: e
      };
    });
  });
},
    fetchSections = function fetchSections(e, t, s) {
  var i = new h();
  i.append("spatialReference", "wgs84"), e && i.append("state", e), t && i.append("township", t), s && i.append("range", s);
  var a = g("plss/section?".concat(i.toString()));
  return r.get(a).then(function (e) {
    var t = e.results;
    return t.map(transformShape);
  });
},
    u = Object.freeze({
  __proto__: null,
  fetchStates: fetchStates,
  fetchTownships: fetchTownships,
  fetchRanges: fetchRanges,
  fetchSections: fetchSections,
  spatialCountyEsriFields: [{
    name: "Name",
    type: "esriFieldTypeString"
  }, {
    name: "State",
    type: "esriFieldTypeString"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedSpatialCountyFields: {
    name: "Name",
    state: "State"
  },
  fetchSpatialCounties: function fetchSpatialCounties(e) {
    return fetchSpatial("county", e);
  },
  spatialCountyToGraphic: function spatialCountyToGraphic(e) {
    return o.toFeature(e, "shape");
  },
  spatialTownshipEsriFields: [{
    name: "Township",
    type: "esriFieldTypeString"
  }, {
    name: "Range",
    type: "esriFieldTypeString"
  }, {
    name: "LndKey",
    type: "esriFieldTypeString"
  }, {
    name: "State",
    type: "esriFieldTypeString"
  }, {
    name: "Meridian",
    type: "esriFieldTypeString"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedSpatialTownshipFields: {
    township: "Township",
    range: "Range",
    lndKey: "LndKey",
    state: "State",
    meridian: "Meridian"
  },
  fetchSpatialTownships: function fetchSpatialTownships(e) {
    return fetchSpatial("township", e);
  },
  spatialTownshipToGraphic: function spatialTownshipToGraphic(e) {
    return o.toFeature(e, "shape");
  },
  spatialSectionEsriFields: [{
    name: "Section",
    type: "esriFieldTypeString"
  }, {
    name: "Township",
    type: "esriFieldTypeString"
  }, {
    name: "Range",
    type: "esriFieldTypeString"
  }, {
    name: "LndKey",
    type: "esriFieldTypeString"
  }, {
    name: "State",
    type: "esriFieldTypeString"
  }, {
    name: "Meridian",
    type: "esriFieldTypeString"
  }, {
    name: "Shape",
    type: "esriFieldTypeGeometry"
  }],
  mappedSpatialSectionFields: {
    section: "Section",
    township: "Township",
    range: "Range",
    lndKey: "LndKey",
    state: "State",
    meridian: "Meridian"
  },
  fetchSpatialSections: function fetchSpatialSections(e) {
    return fetchSpatial("section", e);
  },
  spatialSectionToGraphic: function spatialSectionToGraphic(e) {
    return o.toFeature(e, "shape");
  }
});

var SearchTools = /*#__PURE__*/function () {
  function SearchTools(e, t) {
    _classCallCheck(this, SearchTools);

    this.states = [], this.townships = [], this.ranges = [], this.sections = [], this.firstOpen = !0, this.isLoadingPLSS = !0, this.errors = {}, this.nonFieldFeatures = [], this.eventIds = [], this.selectedState = "", this.selectedTownship = "", this.selectedRange = "", this.selectedSection = "", this.searchValue = "", this.selectedNonFieldFeature = "", this.selectedEventId = "", this.mapView = e, this.options = t, this.pinMarker = m.fromJSON(d.symbols.search.pin), this.plssFillSymbol = m.fromJSON(d.symbols.search.plss), this._clearXYErrorFlags();
  }

  _createClass(SearchTools, [{
    key: "_clearLoading",
    value: function _clearLoading() {
      this.isLoadingPLSS = !1, this._forceUpdate();
    }
  }, {
    key: "_clearXYErrorFlags",
    value: function _clearXYErrorFlags() {
      this._setError("x", !1), this._setError("y", !1);
    }
  }, {
    key: "_forceUpdate",
    value: function _forceUpdate() {
      this.options.forceUpdate && this.options.forceUpdate();
    }
  }, {
    key: "update",
    value: function update(e) {}
  }, {
    key: "_handleError",
    value: function _handleError(e) {
      console.error(e), this._clearLoading();
    }
  }, {
    key: "_handleXYKeyDown",
    value: function _handleXYKeyDown(e) {
      "Enter" === e.key && this.findXY(this.x, this.y);
    }
  }, {
    key: "_loadPlss",
    value: function _loadPlss() {
      var _this = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : l.STATE;

      switch (this._startLoading(), e) {
        case l.STATE:
          fetchStates().then(function (e) {
            _this.states = e.map(function (e) {
              return {
                value: e.name,
                label: e.name,
                selected: !1
              };
            }), _this._clearLoading();
          }).catch(this._handleError);
          break;

        case l.TOWNSHIP:
          fetchTownships(this.selectedState).then(function (e) {
            _this.townships = e.map(function (e) {
              return {
                value: e.name,
                label: _this._trimLeadingZeros(e.name),
                selected: !1
              };
            }), _this._clearLoading();
          }).catch(this._handleError);
          break;

        case l.RANGE:
          fetchRanges(this.selectedState, this.selectedTownship).then(function (e) {
            _this.ranges = e.map(function (e) {
              return {
                value: e.name,
                label: _this._trimLeadingZeros(e.name),
                selected: !1
              };
            }), _this._clearLoading();
          }).catch(this._handleError);
          break;

        case l.SECTION:
          fetchSections(this.selectedState, this.selectedTownship, this.selectedRange).then(function (e) {
            _this.sections = e.map(function (e) {
              return {
                value: e.name,
                shape: e.shape,
                label: _this._trimLeadingZeros(e.name),
                selected: !1
              };
            }), _this._clearLoading();
          }).catch(this._handleError);
          break;

        default:
          console.warn("PLSS Type not defined. Unable to query."), this._clearLoading();
      }
    }
  }, {
    key: "_selectPlss",
    value: function _selectPlss(e, t) {
      var _this2 = this;

      switch (this.mapView.graphics.removeAll(), e) {
        case l.STATE:
          this.selectedState = t || "", this.selectedTownship = "", this.townships = [], this.ranges = [], this.sections = [], this._loadPlss(l.TOWNSHIP);
          break;

        case l.TOWNSHIP:
          this.selectedTownship = t || "", this.selectedRange = "", this.selectedSection = null, this.ranges = [], this.sections = [], this._loadPlss(l.RANGE);
          break;

        case l.RANGE:
          this.selectedRange = t || "", this.selectedSection = null, this.sections = [], this._loadPlss(l.SECTION);
          break;

        case l.SECTION:
          this.selectedSection = t || null, this.selectedSection && this.locatePoly(this.sections.find(function (e) {
            return e.value === _this2.selectedSection;
          }).shape);
          break;

        default:
          console.warn("PLSS Type not defined.  Unable to query."), this._clearLoading();
      }

      this._forceUpdate();
    }
  }, {
    key: "_setError",
    value: function _setError(e, t, s) {
      this.errors[e] = {
        hasError: t,
        errorText: s
      };
    }
  }, {
    key: "_startLoading",
    value: function _startLoading() {
      this.isLoadingPLSS = !0, this._forceUpdate();
    }
  }, {
    key: "_trimLeadingZeros",
    value: function _trimLeadingZeros(e) {
      return e.match(/^(0*)(.*)/)[2];
    }
  }, {
    key: "activate",
    value: function activate() {
      this.selectTab(this.selectedTab || 0);
    }
  }, {
    key: "findXY",
    value: function findXY(e, a) {
      var _this$options = this.options,
          r = _this$options.formatMessage,
          o = _this$options.messages;

      this._clearXYErrorFlags();

      var n = Number(e),
          h = Number(a);

      if (!isNaN(n) && !isNaN(h) && -180 <= n && n <= 180 && -90 <= h && h <= 90) {
        this.mapView.graphics.removeAll();

        var _e = new t({
          x: n,
          y: h,
          spatialReference: new i({
            wkid: 4326
          })
        });

        this.mapView.graphics.add(new s({
          geometry: _e,
          symbol: this.pinMarker
        })), this.mapView.zoom >= d.defaultZoomLevel ? this.mapView.goTo({
          center: _e
        }) : this.mapView.goTo({
          center: _e,
          zoom: d.defaultZoomLevel
        });
      } else isNaN(n) ? this._setError("x", !0, r(o.noValueErrorMsg)) : -180 <= n && n <= 180 || this._setError("x", !0, r(o.invalidValueErrorMsg, {
        low: -180,
        high: 180
      })), isNaN(h) ? this._setError("y", !0, r(o.noValueErrorMsg)) : -90 <= h && h <= 90 || this._setError("y", !0, r(o.invalidValueErrorMsg, {
        low: -90,
        high: 90
      })), this._forceUpdate();
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 140,
        leftAndRight: !0,
        width: 320,
        height: 85
      };
    }
  }, {
    key: "locatePoly",
    value: function locatePoly(e) {
      this.mapView.graphics.removeAll(), this.mapView.graphics.add(new s({
        geometry: e,
        symbol: this.plssFillSymbol
      })), this.mapView.graphics.add(new s({
        geometry: e.rings.length > 1 ? e.extent.center : e.centroid,
        symbol: this.pinMarker
      })), this.mapView.goTo({
        target: e.extent.expand(2)
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this3 = this;

      return new Promise(function (e) {
        _this3.mapView.graphics.removeAll(), _this3._clearXYErrorFlags(), _this3.citySearchTool && (_this3.mapView.popup && _this3.mapView.popup.visible && _this3.mapView.popup.close(), _this3.citySearchTool.destroy(), _this3.citySearchTool = null), e();
      });
    }
  }, {
    key: "_getEventIdSearchOptions",
    value: function _getEventIdSearchOptions(e) {
      var _this4 = this;

      this._startLoading();

      c(e, "", "", "", "", [], !0).then(function (e) {
        _this4.eventIds = e.map(function (e) {
          return {
            value: e.fieldGuid,
            label: e.eventId,
            secondaryPropList: e.customerFarmFieldLabel
          };
        }), _this4._clearLoading(), _this4._forceUpdate();
      }).catch(this._handleError);
    }
  }, {
    key: "_searchEventId",
    value: function _searchEventId(e) {
      null != e && (this.selectedEventId = e.eventId, this.options.setZoomToField(e.value));
    }
  }, {
    key: "_getNonFieldFeatureSearchOptions",
    value: function _getNonFieldFeatureSearchOptions() {
      var _this5 = this;

      this._startLoading(), p().then(function (e) {
        _this5.nonFieldFeatures = e.map(function (e) {
          return {
            value: e.id,
            label: e.name,
            secondaryPropList: e.customerName,
            geometries: e.geometries
          };
        }), _this5._clearLoading(), _this5._forceUpdate();
      }).catch(this._handleError);
    }
  }, {
    key: "_selectedNonFieldFeature",
    value: function _selectedNonFieldFeature(e) {
      if (null != e) if (this.selectedNonFieldFeature = e.name, this.options.setZoomToNonFieldFeatures([e]), "polygon" === e.geometries[0].shape.type) this.mapView.graphics.add(new s({
        geometry: e.geometries[0].shape.rings.length > 1 ? e.extent.center : e.geometries[0].shape.centroid,
        symbol: this.pinMarker
      }));else {
        var _i = e.geometries[0].shape.x,
            _a = e.geometries[0].shape.y;
        var _r = e.geometries[0].shape.spatialReference;
        this.mapView.graphics.removeAll();

        var _o = new t({
          x: _i,
          y: _a,
          spatialReference: _r
        });

        this.mapView.graphics.add(new s({
          geometry: _o,
          symbol: this.pinMarker
        })), this.mapView.zoom >= d.defaultZoomLevel ? this.mapView.goTo({
          center: _o
        }) : this.mapView.goTo({
          center: _o,
          zoom: d.defaultZoomLevel
        });
      }
    }
  }, {
    key: "_updateSearchValue",
    value: function _updateSearchValue(e) {
      this.searchValue = e;
    }
  }, {
    key: "selectTab",
    value: function selectTab(t) {
      var _this6 = this;

      switch (this.selectedTab = t, t) {
        case 0:
          setTimeout(function () {
            var t = document.createElement("div");
            _this6.searchCityDiv.append(t), _this6.citySearchTool = new e({
              view: _this6.mapView,
              container: t,
              popupEnabled: !1,
              sources: [new a({
                url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
                singleLineFieldName: "SingleLine",
                outFields: ["Addr_type"],
                name: "ArcGIS World Geocoding Service",
                placeholder: "Find address or place",
                resultSymbol: _this6.pinMarker
              })],
              includeDefaultSources: !1
            }), _this6._getNonFieldFeatureSearchOptions(), _this6._getEventIdSearchOptions(_this6.options.userGuid), _this6._forceUpdate();
          });
          break;

        case 1:
          setTimeout(function () {
            _this6._clearXYErrorFlags(), _this6._forceUpdate();
          });
          break;

        case 2:
          setTimeout(function () {
            var e = _this6.selectedSection || null;
            e && _this6.locatePoly(_this6.sections.find(function (t) {
              return t.value === e;
            }).shape), _this6._forceUpdate();
          });
          break;

        case 3:
          setTimeout(function () {
            _this6._getNonFieldFeatureSearchOptions(), _this6._forceUpdate();
          });
          break;

        case 4:
          setTimeout(function () {
            _this6._getEventIdSearchOptions(_this6.options.userGuid), _this6._forceUpdate();
          });
      }
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      e.expanded ? this.firstOpen ? (this._loadPlss(), this.firstOpen = !1) : this._forceUpdate() : this.reset();
    }
  }]);

  return SearchTools;
}();

export { SearchTools as S, u as r };